var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"title"},[_vm._v("Update Payment")]),_c('div',{staticClass:"body"},[_c('div',[_vm._v("A payment is required for your subscription to remain active. ")]),_c('br'),_c('an-button',{attrs:{"variant":"secondary"},on:{"click":_vm.updatePaymentClick}},[_vm._v("Update Payment")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }